import PricingDetails from './PricingDetails'

export default PricingDetails
